import React, { useContext, useEffect, useState } from 'react';

import { ProductContainerContext } from '@rsc/contexts/ProductContainerContext';
import { DesktopImageCarousel } from './DesktopImageCarousel';
import { MobileImageCarousel } from './MobileImageCarousel';

const ProductImageCarousel = () => {
  const { activeVariant, product, selectedOptions, variants } = useContext(
    ProductContainerContext
  ) as any;

  const [images, setImages] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState(null);

  useEffect(() => {
    const variantMediaIds = variants?.flatMap(v => v.media?.map(m => m.id));
    const sharedMedia = product?.shopifyProduct?.media?.filter(
      item => !variantMediaIds.includes(item.id)
    );

    let newImages = [];
    if (activeVariant?.media?.length) {
      newImages = [...activeVariant.media, ...sharedMedia];
    } else {
      const colorKey = Object.keys(selectedOptions).find(k =>
        k.toLowerCase().includes('color')
      );
      if (colorKey) {
        const variantWithSameColorImage =
          product?.shopifyProduct?.variants.find(variant => {
            const relatedOption = variant.selectedOptions.find(
              o => o.name === colorKey
            );
            return relatedOption.value === selectedOptions[colorKey];
          });
        newImages = [...variantWithSameColorImage.media, ...sharedMedia];
      } else {
        newImages = sharedMedia;
      }
    }

    setImages(newImages);
  }, [activeVariant, product, selectedOptions, variants]);

  return (
    <div className="min-h-[380px]">
      <DesktopImageCarousel
        images={images}
        selectedMedia={selectedMedia ?? images?.[0]}
        setSelectedMedia={setSelectedMedia}
      />
      <MobileImageCarousel
        images={images}
        selectedMedia={selectedMedia ?? images?.[0]}
        setSelectedMedia={setSelectedMedia}
      />
    </div>
  );
};

export default ProductImageCarousel;
